import { render, staticRenderFns } from "./RegisterDialog.vue?vue&type=template&id=506a0f14&scoped=true&"
import script from "./RegisterDialog.vue?vue&type=script&lang=js&"
export * from "./RegisterDialog.vue?vue&type=script&lang=js&"
import style0 from "./RegisterDialog.vue?vue&type=style&index=0&id=506a0f14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506a0f14",
  null
  
)

export default component.exports